// src/theme/ThemeContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  // "dark" ou "light"
  const [theme, setTheme] = useState("dark");

  // Charger le thème depuis localStorage au démarrage
  useEffect(() => {
    try {
      const saved = window.localStorage.getItem("eternua_theme");
      if (saved === "light" || saved === "dark") {
        setTheme(saved);
      }
    } catch (e) {
      // ignore
    }
  }, []);

  // Sauver à chaque changement
  useEffect(() => {
    try {
      window.localStorage.setItem("eternua_theme", theme);
    } catch (e) {
      // ignore
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((t) => (t === "dark" ? "light" : "dark"));
  };

  const value = {
    theme,        // "dark" ou "light"
    isDark: theme === "dark",
    isLight: theme === "light",
    toggleTheme,
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

// Hook pratique
export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error("useTheme doit être utilisé à l'intérieur de <ThemeProvider>");
  }
  return ctx;
}
